<style lang="scss">
h1,
h2,
h3,
h4,
h5,
h6 {
  color: white;
}
.chars {
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.module-num {
  width: 157px;
  height: auto;
  position: absolute;
  bottom: 50px;
  left: 80px;
}
.logo {
  position: absolute;
  width: 228px;
  height: auto;
  top: 54px;
  left: 45px;
}
.flipbook {
  width: 100%;
  height: 100%;
}
.swiper-slide > div {
  height: 100%;
}
p {
  font-size: 34px;
  line-height: 40px;
}
.pages {
  display: flex;
  flex-direction: row;
  padding: 0 5%;
  width: 100%;
  box-sizing: border-box;
}
.page {
  width: 40%;
  font-size: 2rem;
  flex-basis: 50%;
  color: #fff;
  box-sizing: border-box;
}
.page-left {
  padding-right: 5%;
}
.page-right {
  padding-left: 5%;
}
.copy {
  margin-bottom: 1.5em;
}
</style>

<template>
  <main class="module home module3">
    <AppContainer>
      <Flipbook
        v-if="!showSwiper"
        @flip-right-end="openBook"
        class="flipbook"
        :nPolygons="5"
        :zooms="null"
        :pages="[
          null,
          require(`@/assets/module${book}/front.jpg`),
          require(`@/assets/module${book}/page_1_left.jpg`),
          require(`@/assets/module${book}/page_1_right.jpg`)
        ]"
        :numPages="2"
      ></Flipbook>
      <div
        :style="{
          opacity: showSwiper ? 1 : 0,
          visibility: showSwiper ? 'visible' : 'hidden'
        }"
        class="container"
      >
        <Swiper @slide-change="slideChange" book-name="Three">
          <SwiperSlide>
            <transition name="slidefade">
              <Slide1 v-if="showSlide(1)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide2 v-if="showSlide(2)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide3 v-if="showSlide(3)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide4 v-if="showSlide(4)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide5 v-if="showSlide(5)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide6 v-if="showSlide(6)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide7
                v-if="showSlide(7)"
                :slide-index="slideIndex"
                @emit-blob="registerBlob"
                @emit-blob-fn="registerDownloadFn"
              />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide8 v-if="showSlide(8)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide9 v-if="showSlide(9)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide10
                v-if="showSlide(10)"
                :slide-index="slideIndex"
                @emit-blob="registerBlob"
                @emit-blob-fn="registerDownloadFn"
              />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide11 v-if="showSlide(11)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide12 v-if="showSlide(12)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide13 v-if="showSlide(13)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide14 v-if="showSlide(14)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide15 v-if="showSlide(15)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
          <SwiperSlide>
            <transition name="slidefade">
              <Slide16 v-if="showSlide(16)" :slide-index="slideIndex" />
            </transition>
          </SwiperSlide>
        </Swiper>
      </div>
    </AppContainer>
  </main>
</template>
<script>
// @ is an alias to /src
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import AppContainer from "@/components/AppContainer";
import Flipbook from "flipbook-vue";
import Slide1 from "./slides/Slide1";
import Slide2 from "./slides/Slide2";
import Slide3 from "./slides/Slide3";
import Slide4 from "./slides/Slide4";
import Slide5 from "./slides/Slide5";
import Slide6 from "./slides/Slide6";
import Slide7 from "./slides/Slide7";
import Slide8 from "./slides/Slide8";
import Slide9 from "./slides/Slide9";
import Slide10 from "./slides/Slide10";
import Slide11 from "./slides/Slide11";
import Slide12 from "./slides/Slide12";
import Slide13 from "./slides/Slide13";
import Slide14 from "./slides/Slide14";
import Slide15 from "./slides/Slide15";
import Slide16 from "./slides/Slide16";

export default {
  name: "Module3",
  data() {
    return {
      showSwiper: false,
      slideIndex: 0,
      imageBlob10:
        window?.CF_EBOOK_VARS?.documents?.book_3_document_1?.url || "#",
      imageId10:
        window?.CF_EBOOK_VARS?.documents?.book_3_document_1?.document_id || "#",
      imageDownloadFn: undefined,
      book: 3
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    AppContainer,
    Flipbook,
    Slide1,
    Slide2,
    Slide3,
    Slide4,
    Slide5,
    Slide6,
    Slide7,
    Slide8,
    Slide9,
    Slide10,
    Slide11,
    Slide12,
    Slide13,
    Slide14,
    Slide15,
    Slide16
  },
  methods: {
    showSlide(slideNum) {
      return (
        slideNum - 1 > this.slideIndex - 1 && slideNum - 1 < this.slideIndex + 2
      );
    },
    slideChange(index) {
      this.slideIndex = index;
    },
    openBook() {
      this.showSwiper = true;
      console.log("OPEN", 1);
    },
    registerBlob(blob) {
      this.imageBlob = blob;
    },
    registerDownloadFn(fn) {
      this.imageDownloadFn = fn;
    }
  }
};
</script>
